import {
  CandlestickChart,
  ShieldCheck,
  Brain,
  ListChecks,
  GraduationCap,
  TrendingUp,
} from "lucide-react";
import { CURRICULUM, MARKETS } from "@/lib/content";
import { Reveal, SectionLabel } from "@/components/landing/Reveal";

const iconMap = {
  chart: CandlestickChart,
  shield: ShieldCheck,
  brain: Brain,
  discipline: ListChecks,
  practical: GraduationCap,
  strategy: TrendingUp,
};

export const Curriculum = () => (
  <section className="relative bg-ink2 px-4 py-16 sm:px-8 lg:py-24" data-testid="curriculum-section">
    <div className="mx-auto max-w-6xl">
      <Reveal className="max-w-2xl">
        <SectionLabel>What You'll Learn</SectionLabel>
        <h2 className="mt-4 font-display text-5xl font-bold uppercase leading-none tracking-tight text-offwhite sm:text-6xl">
          What You'll Actually Learn
        </h2>
      </Reveal>

      <div className="mt-10 grid gap-4 sm:grid-cols-2 lg:grid-cols-3">
        {CURRICULUM.map((c, i) => {
          const Icon = iconMap[c.icon];
          return (
            <Reveal key={c.title} delay={i * 0.06}>
              <div className="card-surface group h-full rounded-2xl p-6 sm:p-7">
                <div className="flex h-14 w-14 items-center justify-center rounded-2xl border border-em2/25 bg-em1/10 text-em2 transition-transform duration-300 group-hover:scale-110">
                  <Icon size={26} strokeWidth={1.6} />
                </div>
                <h3 className="mt-4 font-heading text-xl font-bold text-offwhite">{c.title}</h3>
                <p className="mt-2 text-sm leading-relaxed text-mutedgreen">{c.body}</p>
              </div>
            </Reveal>
          );
        })}
      </div>

      <Reveal delay={0.15}>
        <div className="mt-8 flex flex-col items-start gap-4 rounded-2xl border border-surfaceline bg-surface p-6 sm:flex-row sm:items-center sm:justify-between">
          <p className="text-xs font-bold uppercase tracking-[0.24em] text-gold">
            Markets Covered
          </p>
          <div className="flex flex-wrap gap-2.5">
            {MARKETS.map((m) => (
              <span
                key={m}
                className="rounded-full border border-em2/30 bg-em2/10 px-4 py-2 text-sm font-semibold text-em2"
              >
                {m}
              </span>
            ))}
          </div>
        </div>
      </Reveal>
    </div>
  </section>
);
